import { render, staticRenderFns } from "./CustomerAttachments.vue?vue&type=template&id=d170be94&scoped=true"
import script from "./CustomerAttachments.vue?vue&type=script&lang=js"
export * from "./CustomerAttachments.vue?vue&type=script&lang=js"
import style0 from "./CustomerAttachments.vue?vue&type=style&index=0&id=d170be94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d170be94",
  null
  
)

export default component.exports